window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-StainedGlass"] = {
  "meta": {
    "appearance": {
      "background_color": "#ffffff",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#cfcfcf",
      "border_radius_px": 0,
      "border_scope": "image_text",
      "border_size": 0,
      "gradient_angle": 42,
      "gradient_color": "#ffffff",
      "image_radius_px": 0,
      "product_image_padding": 0,
      "shadow_size": 0,
      "text_behavior": "wrap_text",
      "text_color": "#000000",
      "text_size_desktop": 13,
      "text_size_mobile": 12,
      "text_style": "normal"
    },
    "selected_appearance": {
      "background_color": "#ffffff",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#12316f",
      "border_radius_px": 0,
      "border_scope": "image_text",
      "border_size": 0,
      "gradient_color": "#ffffff",
      "image_radius_px": 0,
      "product_image_padding": 0,
      "shadow_size": 0,
      "text_color": "#000000",
      "text_style": "normal",
      "text_size_mobile": 12,
      "text_size_desktop": 13
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "custom_html": "<span hidden data-stained-glass-colors></span><style>:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-wrap{--mgps-row-aspect:1 / 1!important;aspect-ratio:1 / 1!important;height:auto!important;min-height:0!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner img{width:100%!important;height:100%!important;object-fit:contain!important;object-position:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) img[src*=\"Stained-Glass-View-All\"]{transform:none!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-title{white-space:normal!important;overflow-wrap:normal!important;word-break:normal!important;transform:none!important;line-height:1.2!important}.mgps-row:has([data-stained-glass-colors]){display:none!important}.mgps-modal:has([data-stained-glass-colors]){align-items:center!important;justify-content:center!important;padding:16px!important;box-sizing:border-box!important}.mgps-modal:has([data-stained-glass-colors]) .mgps-modal__dialog{width:min(1100px,calc(100vw - 32px))!important;max-height:calc(100dvh - 32px)!important;margin:0!important}.mgps-modal:has([data-stained-glass-colors]) .mgps-modal__body{min-height:0!important;max-height:calc(100dvh - 100px)!important;overflow:auto!important;overscroll-behavior:contain}.mgps-modal:has([data-stained-glass-colors]) .mgps-thumb-row{justify-content:center!important}@media(max-width:749px){.mgps-modal:has([data-stained-glass-colors]){padding-inline:8px!important}.mgps-modal:has([data-stained-glass-colors]) .mgps-modal__dialog{width:calc(100vw - 16px)!important;max-width:calc(100vw - 16px)!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-card-bottom{padding:6px 3px!important;min-height:38px!important;box-sizing:border-box!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-title{font-size:12px!important}}\n:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-card-bottom{padding:8px 8px 10px!important;min-height:50px!important;box-sizing:border-box!important}@media(max-width:749px){:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-card-bottom{padding:6px 2px 8px!important;min-height:42px!important}}</style><style data-sge-floating-glass>:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-thumb-block,:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-wrap,:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-card-bottom{border:0!important;border-radius:0!important;box-shadow:none!important;background:#ffffff!important;background-image:none!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-thumb-block{overflow:visible!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner img{transition:none!important;translate:none!important;scale:none!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) a[aria-current=\"page\"] .mgps-title{text-decoration:underline;text-underline-offset:4px;font-weight:700!important}@media(prefers-reduced-motion:reduce){:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner img{transition:none!important;translate:0 0!important;scale:1!important}}</style><style data-sge-equal-glass>:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP01-red-glass-swatch-20261029\"]){transform:translate(0.797%,1.671%) scale(1.00000,1.02564)!important;transform-origin:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP02-flame-orange-glass-swatch-20261029\"]){transform:translate(0.839%,0.969%) scale(1.00147,1.00946)!important;transform-origin:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP03-amber-brown-glass-swatch-20261029\"]){transform:translate(0.834%,2.331%) scale(0.99561,1.03896)!important;transform-origin:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP04-yellow-glass-swatch-20261029\"]){transform:translate(0.910%,-0.814%) scale(0.99270,0.96482)!important;transform-origin:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP05-lime-glass-swatch-20261029\"]){transform:translate(0.839%,4.023%) scale(1.00147,1.07987)!important;transform-origin:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP06-emerald-glass-swatch-20261029\"]){transform:translate(1.145%,0.934%) scale(0.98981,1.01053)!important;transform-origin:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP07-sky-blue-glass-swatch-20261029\"]){transform:translate(0.951%,-1.601%) scale(0.95372,0.95904)!important;transform-origin:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP08-cobalt-glass-swatch-20261029\"]){transform:translate(0.756%,1.944%) scale(0.99853,1.03004)!important;transform-origin:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP09-purple-glass-swatch-20261029\"]){transform:translate(0.949%,-3.072%) scale(0.88197,0.90141)!important;transform-origin:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP11-magenta-glass-swatch-20261029\"]){transform:translate(0.892%,-2.228%) scale(0.97282,0.93750)!important;transform-origin:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP12-black-glass-swatch-20261029\"]){transform:translate(1.222%,-1.219%) scale(0.95775,0.95904)!important;transform-origin:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP60-white-pearl-glass-swatch-20261029\"]){transform:translate(0.940%,-1.066%) scale(0.98266,0.95904)!important;transform-origin:center!important}:is([data-mg-set=\"Colors-StainedGlass\"],[data-mg-set$=\"-stained_glass_colors\"],[id$=\"__stained_glass_colors\"],.mgps-modal:has([data-stained-glass-colors])) .mgps-img-inner:has(img[src*=\"SGE-DTGP30-clear-texture-glass-swatch-20261029\"]){transform:translate(1.127%,-0.737%) scale(0.94183,0.94581)!important;transform-origin:center!important}</style>",
      "custom_max_width_px": "0",
      "custom_template_id": "mgps-custom-stained-glass-colors",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "fit_row": false,
      "heading": "",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "margin_bottom": 0,
      "margin_top": "0",
      "row_height": 0,
      "row_justify": "center",
      "subheading": "",
      "swatch_row": false,
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "find_product_handle_contains": "",
      "fit_row": true,
      "heading": "<h2>Stained glass colors</h2>",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "margin_bottom": 10,
      "margin_top": 0,
      "more_popup_text": "More",
      "padding_between_rows": 8,
      "padding_between_rows_desktop": 8,
      "padding_between_rows_mobile": 8,
      "product_handle_contains": "",
      "random_zoom_max": "0",
      "randomize_zoom_area": false,
      "row_display_type": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type_mobile": "scale_to_fit",
      "row_height": "0",
      "row_height_desktop": "0",
      "row_height_mobile": "0",
      "row_justify": "center",
      "subheading": "",
      "swatch_image_zoom": "100",
      "swatch_row": true,
      "swatch_vertical_justify": "fit_to_height",
      "swatches": [
        {
          "alt": "DecoArt® Red stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-red",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460319985798,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP01-red-2oz-bottle.png?v=1793319922&width=400",
          "product_url": "/products/stained-glass-paint-red",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP01-red-glass-swatch-20261029.png?width=400",
          "title": "Red",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Flame Orange stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-flame-orange",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320051334,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP02-flame-orange-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-flame-orange",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP02-flame-orange-glass-swatch-20261029.png?width=400",
          "title": "Flame Orange",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Amber Brown stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-amber-brown",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320084102,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP03-amber-brown-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-amber-brown",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP03-amber-brown-glass-swatch-20261029.png?width=400",
          "title": "Amber Brown",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Yellow stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-yellow",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320215174,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP04-yellow-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-yellow",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP04-yellow-glass-swatch-20261029.png?width=400",
          "title": "Yellow",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Lime stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-lime",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320280710,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP05-lime-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-lime",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP05-lime-glass-swatch-20261029.png?width=400",
          "title": "Lime",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Emerald stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-emerald",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320346246,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP06-emerald-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-emerald",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP06-emerald-glass-swatch-20261029.png?width=400",
          "title": "Emerald",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Sky Blue stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-sky-blue",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320411782,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP07-sky-blue-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-sky-blue",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP07-sky-blue-glass-swatch-20261029.png?width=400",
          "title": "Sky Blue",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Cobalt stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-cobalt",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320510086,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP08-cobalt-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-cobalt",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP08-cobalt-glass-swatch-20261029.png?width=400",
          "title": "Cobalt",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Purple stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-purple",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320575622,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP09-purple-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-purple",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP09-purple-glass-swatch-20261029.png?width=400",
          "title": "Purple",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Magenta stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-magenta",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320641158,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP11-magenta-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-magenta",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP11-magenta-glass-swatch-20261029.png?width=400",
          "title": "Magenta",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Black stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-black",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320772230,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP12-black-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-black",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP12-black-glass-swatch-20261029.png?width=400",
          "title": "Black",
          "type": "product",
          "vjust": "center"
        },
        {
          "button_appearance_source": "inherit_from_parent",
          "button_image": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Stained-Glass-View-All-Gold-20261029.png?width=400",
          "button_image_alt": "View all gold-edged Stained Glass Paint swatches",
          "button_justify": "left",
          "button_margin_top": "10",
          "button_max_width_px": "0",
          "button_style": "swatch",
          "button_text": "<p>View All</p>",
          "button_width_percent": 100,
          "include_visible_swatches_in_popup": true,
          "popup_swatches_per_row_desktop": "6",
          "popup_swatches_per_row_mobile": "4",
          "popup_title": "",
          "preset_button_background_color": "#ffffff",
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_border_color": "#cfcfcf",
          "preset_button_border_radius_px": 0,
          "preset_button_border_scope": "image_text",
          "preset_button_border_size": 0,
          "preset_button_gradient_angle": 42,
          "preset_button_gradient_color": "#ffffff",
          "preset_button_heading_justify": "left",
          "preset_button_image": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Stained-Glass-View-All-Gold-20261029.png?width=400",
          "preset_button_image_alt": "View all gold-edged Stained Glass Paint swatches",
          "preset_button_image_height_desktop": "0",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_radius_px": 0,
          "preset_button_product_image_padding": 0,
          "preset_button_shadow_size": 0,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_color": "#000000",
          "preset_button_text_size_desktop": 14,
          "preset_button_text_size_mobile": 13,
          "preset_button_text_style": "normal",
          "type": "popup_remaining_swatches_trigger"
        },
        {
          "alt": "DecoArt® White Pearl stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-white-pearl",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320804998,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP60-white-pearl-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-white-pearl",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP60-white-pearl-glass-swatch-20261029.png?width=400",
          "title": "White Pearl",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Clear Texture stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-clear-texture",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320870534,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP30-clear-texture-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-clear-texture",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP30-clear-texture-glass-swatch-20261029.png?width=400",
          "title": "Clear Texture",
          "type": "product",
          "vjust": "center"
        }
      ],
      "swatches_per_row": 6,
      "swatches_per_row_desktop": 6,
      "swatches_per_row_mobile": 4,
      "videos": [
        {
          "alt": "DecoArt® Red stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-red",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460319985798,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP01-red-2oz-bottle.png?v=1793319922&width=400",
          "product_url": "/products/stained-glass-paint-red",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP01-red-glass-swatch-20261029.png?width=400",
          "title": "Red",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Flame Orange stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-flame-orange",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320051334,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP02-flame-orange-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-flame-orange",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP02-flame-orange-glass-swatch-20261029.png?width=400",
          "title": "Flame Orange",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Amber Brown stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-amber-brown",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320084102,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP03-amber-brown-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-amber-brown",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP03-amber-brown-glass-swatch-20261029.png?width=400",
          "title": "Amber Brown",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Yellow stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-yellow",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320215174,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP04-yellow-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-yellow",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP04-yellow-glass-swatch-20261029.png?width=400",
          "title": "Yellow",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Lime stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-lime",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320280710,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP05-lime-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-lime",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP05-lime-glass-swatch-20261029.png?width=400",
          "title": "Lime",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Emerald stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-emerald",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320346246,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP06-emerald-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-emerald",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP06-emerald-glass-swatch-20261029.png?width=400",
          "title": "Emerald",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Sky Blue stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-sky-blue",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320411782,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP07-sky-blue-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-sky-blue",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP07-sky-blue-glass-swatch-20261029.png?width=400",
          "title": "Sky Blue",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Cobalt stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-cobalt",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320510086,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP08-cobalt-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-cobalt",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP08-cobalt-glass-swatch-20261029.png?width=400",
          "title": "Cobalt",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Purple stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-purple",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320575622,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP09-purple-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-purple",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP09-purple-glass-swatch-20261029.png?width=400",
          "title": "Purple",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Magenta stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-magenta",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320641158,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP11-magenta-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-magenta",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP11-magenta-glass-swatch-20261029.png?width=400",
          "title": "Magenta",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Black stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-black",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320772230,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP12-black-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-black",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP12-black-glass-swatch-20261029.png?width=400",
          "title": "Black",
          "type": "product",
          "vjust": "center"
        },
        {
          "button_appearance_source": "inherit_from_parent",
          "button_image": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Stained-Glass-View-All-Gold-20261029.png?width=400",
          "button_image_alt": "View all gold-edged Stained Glass Paint swatches",
          "button_justify": "left",
          "button_margin_top": "10",
          "button_max_width_px": "0",
          "button_style": "swatch",
          "button_text": "<p>View All</p>",
          "button_width_percent": 100,
          "include_visible_swatches_in_popup": true,
          "popup_swatches_per_row_desktop": "6",
          "popup_swatches_per_row_mobile": "4",
          "popup_title": "",
          "preset_button_background_color": "#ffffff",
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_border_color": "#cfcfcf",
          "preset_button_border_radius_px": 0,
          "preset_button_border_scope": "image_text",
          "preset_button_border_size": 0,
          "preset_button_gradient_angle": 42,
          "preset_button_gradient_color": "#ffffff",
          "preset_button_heading_justify": "left",
          "preset_button_image": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Stained-Glass-View-All-Gold-20261029.png?width=400",
          "preset_button_image_alt": "View all gold-edged Stained Glass Paint swatches",
          "preset_button_image_height_desktop": "0",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_radius_px": 0,
          "preset_button_product_image_padding": 0,
          "preset_button_shadow_size": 0,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_color": "#000000",
          "preset_button_text_size_desktop": 14,
          "preset_button_text_size_mobile": 13,
          "preset_button_text_style": "normal",
          "type": "popup_remaining_swatches_trigger"
        },
        {
          "alt": "DecoArt® White Pearl stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-white-pearl",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320804998,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP60-white-pearl-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-white-pearl",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP60-white-pearl-glass-swatch-20261029.png?width=400",
          "title": "White Pearl",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Clear Texture stained glass paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-clear-texture",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$5.28",
          "price_num": 5.28,
          "product_id": 15460320870534,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP30-clear-texture-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-clear-texture",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SGE-DTGP30-clear-texture-glass-swatch-20261029.png?width=400",
          "title": "Clear Texture",
          "type": "product",
          "vjust": "center"
        }
      ]
    }
  ]
};

// Stained Glass uses the same native sizing lifecycle as Glass Paint.
(function(){
 if(window.__riStainedGlassVisualUI)return;window.__riStainedGlassVisualUI=true;
 var observed=new WeakSet();
 function refresh(){
  var roots=document.querySelectorAll('[data-mg-set$="-stained_glass_colors"],.mgps-modal:has([data-stained-glass-colors])');
  var styles=Array.from(new Set(Array.from(document.querySelectorAll('[data-mg-set$="-stained_glass_colors"] style')).map(function(s){return s.textContent;}))).join('\n');
  if(styles){var style=document.getElementById('ri-stained-glass-native-styles');if(!style){style=document.createElement('style');style.id='ri-stained-glass-native-styles';document.head.appendChild(style);}if(style.textContent!==styles)style.textContent=styles;}
  var title=(document.querySelector('.product-meta__title')||{}).textContent||'',color=title.split(' - ').pop().trim();
  roots.forEach(function(root){root.querySelectorAll('.mgps-thumb-block').forEach(function(a){var label=a.querySelector('.mgps-title');if(!label)return;var selected=label.textContent.trim()===color;if(selected&&a.getAttribute('aria-current')!=='page')a.setAttribute('aria-current','page');else if(!selected&&a.hasAttribute('aria-current'))a.removeAttribute('aria-current');});if(!observed.has(root)){observed.add(root);new MutationObserver(refresh).observe(root,{childList:true,subtree:true});}});
 }
 function ready(){refresh();new MutationObserver(refresh).observe(document.body,{childList:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
 document.addEventListener('media_gallery_sets_ready',refresh);document.addEventListener('shopify:section:load',refresh);
})();
